"use strict";

import angular from "angular";

import template from "./dashboard-main-section.component.html";
import "./dashboard-main-section.component.scss";

import _ from "lodash";

class DashboardMainSectionComponent {
    constructor($mdMedia, $filter) {
        this.$mdMedia = $mdMedia;
        this.$filter = $filter;
        this.screenSize = this.screenSizeGet();
        this.columnsSizes = [];
    }

    $onInit() {
        this.configGrid();
    }

    $onChanges(changes) {
        if (
            !_.isEmpty(_.get(changes, "visualizations.previousValue") || {}) ||
            changes.height
        ) {
            this.configGrid();
        }
    }

    configGrid() {
        const isDre = this.visualizations?.[0]?.name?.indexOf("DRE") > -1;
        const height = isDre && this.height < 30 ? 30 : this.height;
        this.rowHeight = this.heightGet(height);
        this._setColumnsSizes();
    }

    _setColumnsSizes() {
        if (this.columns) this.columnsSizes = this.columns.split(",");
        if (this.template)
            this.columnsSizes = this.$filter("columnSize")(this.template);
    }

    /**
     * @public
     * Pega o valor e soma com a porcentagem do mesmo
     * @param {Number} value valor
     * @param {Number} percentage porcentagem
     * @returns {Number} valor mais a soma da porcentagem do mesmo
     */
    sumValueAndPercentage = (value) => (percentage) =>
        value * percentage + value;

    /**
     * @public
     * calcula a porcentagem do componente em relação às alturas do body, period navbar e title
     * @param {Number} height porcentagem do componente
     * @returns {Object} height% do componente em relação às alturas
     */
    heightGet(height) {
        if (typeof height === "string") return height;
        const bodyHeight = document.body.offsetHeight;
        const heightFree = bodyHeight - 120;
        const resultHeight = this.sumValueAndPercentage(
            heightFree * (height * 0.009)
        );
        const sumHeightAndPercentage = resultHeight(this.screenSize);
        if (heightFree < sumHeightAndPercentage)
            return `${
                typeof this.screenSize === "number" ? heightFree + "px" : "auto"
            }`;
        return `${
            typeof this.screenSize === "number"
                ? sumHeightAndPercentage + "px"
                : "auto"
        }`;
    }

    /**
     * @public
     * Verifica qual o tamanho da tela e retorna uma porcentagem
     * @returns {number || string} height% do componente em relação às alturas
     */
    screenSizeGet = () => {
        const screenList = [
            {
                isOnScreen:
                    this.$mdMedia("(max-height: 799px)") &&
                    this.$mdMedia("(min-width: 1024px)"),

                percentage: 0.6
            },
            {
                isOnScreen:
                    this.$mdMedia("(min-height: 800px)") &&
                    this.$mdMedia("(min-width: 1024px)"),

                percentage: 0.01
            }
        ];
        const screen = screenList
            .filter((screen) => screen.isOnScreen)
            .map((screen) => screen.percentage);

        return screen && screen.length > 0 ? _.head(screen) : "auto";
    };
}

export { DashboardMainSectionComponent };

DashboardMainSectionComponent.$inject = ["$mdMedia", "$filter"];

const name = "dashboardMainSectionComponent";
const def = {
    bindings: {
        height: "<",
        columns: "<",
        template: "<",
        cells: "<",
        visualizations: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        editMode: "<",
        visualizationOptions: "<",
        currentFilterGroup: "<",
        companyData: "<",
        npsData: "<"
    },
    controller: DashboardMainSectionComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
